import { HTTP } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";

export function callApiLayDanhSachNhomChucVu(payload) {
  return HTTP({
    url: ENDPOINT.NHOM_CHUC_VU.ALL,
    method: "GET",
    params: payload
  });
}

export function callApiTaoNhomChucVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.NHOM_CHUC_VU.CRUD, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function callApiSuaNhomChucVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.put(ENDPOINT.NHOM_CHUC_VU.CRUD, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function callApiXoaNhomChucVu(payload) {
  return HTTP({
    url: ENDPOINT.NHOM_CHUC_VU.CRUD + "/" + payload.id,
    method: "DELETE"
  });
}

export function callApiCapNhatThuTu(payload) {
  return HTTP({
    url: ENDPOINT.NHOM_CHUC_VU.ORDER,
    method: "PATCH",
    data: payload
  });
}

export function callApiLayDanhSachNhomChucVuPaging(payload) {
  return HTTP({
    url: ENDPOINT.NHOM_CHUC_VU.SEARCH,
    method: "GET",
    params: payload
  });
}
